'use client'
import styles from './style.module.scss';
import Link from 'next/link';
import { motion } from 'framer-motion';
import { slide, scale } from '../../anim';


interface BurgerLinkProps { 
  data : any,
  isActive: boolean,
  setSelectedIndicator:(arg:boolean) => void;

}
export const BurgerLink =   ({data, isActive, setSelectedIndicator} : BurgerLinkProps) => {
  
    const { title, link, index} = data;
  
    return (
      <motion.div className={styles.link} onMouseEnter={() => {setSelectedIndicator(link)}} custom={index} variants={slide} initial="initial" animate="enter" exit="exit">
        <motion.div variants={scale} animate={isActive ? "open" : "closed"} className={styles.indicator}></motion.div>
        <Link href={link}>{title}</Link>
      </motion.div>
    )
  }